import { Dialog } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import { IDataSetores } from "../../../types/api/estoque/pesquisar-setores";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";


export default function SelectSetoresMultiple({
    value,
    onChange,
    required = false,
    error = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    return (
        <>
            <MultipleChipsField
                value={value}
                label="Setores"
                formatChipLabel={(item) => `${item.id} - ${item.nome}`}
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        multiple
                        possuiBtnLimpar
                        title="Selecionar setores"
                        queryPath="estoque/pesquisar-setores"
                        getItemKey={(item) => item?.id ?? 0}
                        getItemLabel={(item) => item ? `${item.id} - ${item.nome}` : ''}
                        defaultValue={value ?? []}
                        onChange={(value) => {
                            onChange(value as IDataSetores[])
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataSetores[] | null
    onChange: (arg: IDataSetores[] | null) => void
    error?: boolean
    required?: boolean
}